import { alpha, Theme } from '@mui/material/styles'
import { ColorSchema } from './palette'

/**
 * A drop shadow tinted with the component's own colour, used by the contained Button and the
 * circular Fab. theme.shadows is neutral grey only, so this cannot come from the MUI scale.
 */
export const colorShadow = (theme: Theme, color: ColorSchema) =>
  `0 8px 16px 0 ${alpha(theme.palette[color].main, 0.24)}`
